import React, { useEffect } from "react";
import SectionHeader from "../Common/SectionHeader/SectionHeader";
import "./ContainerLayoutStyle.scss";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { setLanguage } from "../../Redux/loadingReducer";
import { useLocation, useNavigate } from "react-router-dom";
function ContainerLayout({
  stepNo,
  totalSteps,
  children,
  bgImage,
  backTo,
  nestedChild,
  stepRoutes,
  showHeader=true 
}) {

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { planDetails } = location.state || {};
  const { i18n } = useTranslation();
  const { t } = useTranslation();
  const { selectedLanguage } = useSelector((state) => state.loading);
console.log("plandetails",planDetails);

  const handleLanguage = () => {
    if (selectedLanguage === "en") {
      dispatch(setLanguage("ar")).then(() => {
        i18n.changeLanguage("ar");
      });
    } else {
      dispatch(setLanguage("en")).then(() => {
        i18n.changeLanguage("en");
      });
    }
  };

  const pickUserIdentity = (details = {}) => ({
    name: details.name,
    mobileNumber: details.mobileNumber,
    termsCondition: details.termsCondition
  });

  const handleBack = () => {
    if (location.pathname === "/medical-insurance/personal-information") {
      if (planDetails?.coverPlan === "Individual Medical") {
        navigate("/basic-information", {
          state: { planDetails, showPlans: true },
        });
        return;
      }
      if (planDetails?.coverPlan === "Affordable Health Cover") {
        navigate("/plans/health/affordable-health-cover-plan", {
          state: { planDetails },
        });
        return;
      }
      if (planDetails?.coverPlan === "Unified Domestic Worker") {
        navigate("/plans/health/unified-domestic-worker", {
          state: { planDetails },
        });
        return;
      }
    }

    if (backTo === "/choose-your-plan") {
      navigate(backTo, {
        state: pickUserIdentity(planDetails)
      });
      return;
    }

    if (
      location.pathname === "/plan" &&
      planDetails?.coverPlan === "Affordable Health Cover"
    ) {
      navigate("/plans/health/affordable-health-cover-plan", {
        state: { planDetails },
      });
    } else if (
      location.pathname === "/plan" &&
      planDetails?.coverPlan === "Unified Domestic Worker"
    ) {
      navigate("/plans/health/unified-domestic-worker", {
        state: { planDetails },
      });
    } else if (backTo) {
      navigate(backTo, {
        state: { planDetails },
      });
    } else {
      window.history.back();
    }
  };

  const buildDefaultStepRoutes = () => {
    const coverPlan = planDetails?.coverPlan;
    let step1 = "/basic-information";
    if (coverPlan === "Affordable Health Cover") {
      step1 = "/plans/health/affordable-health-cover-plan";
    } else if (coverPlan === "Unified Domestic Worker") {
      step1 = "/plans/health/unified-domestic-worker";
    }
    return [
      step1,
      "/personal-information",
      "/question/health",
    ];
  };

  const handleStepClick = (targetStep) => {
    if (!stepNo || targetStep >= stepNo) return;
    const routes = Array.isArray(stepRoutes) && stepRoutes.length
      ? stepRoutes
      : buildDefaultStepRoutes();
    const targetPath = routes[targetStep - 1];
    if (targetPath) {
      const targetState =
        targetStep === 1 && planDetails?.coverPlan === "Individual Medical"
          ? { planDetails, showPlans: true }
          : { planDetails };
      navigate(targetPath, {
        state: targetState,
      });
    }
  };

  return (
    <>
      <div className={i18n.dir() === "rtl" ? "rtl-layout" : "ltr-layout"} style={{ backgroundColor: "#f4f4f4ff", position: "relative" }}>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            backgroundColor: "#f4f4f4ff",
            // boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
          }}
        >
          <div className="container-fluid pb-5">
            <div className="row">
              <div className="col-md-12">
                <SectionHeader
                  showHeader={showHeader}
                  title={t("medical insurance")}
                  stepNo={stepNo}
                  totalStep={totalSteps}
                  onBack={handleBack}
                  onStepClick={handleStepClick}
                />
              </div>
            </div>
            <div className="container bg-white mt-2 pb-2">
              <div className="innerwrapper">
                <div className="container">{children}</div>
                {nestedChild ? (
                  <div className="col-md-6">
                    {nestedChild}
                  </div>
                ) : (
                  <div className="col-md-7 p-0 mt-2 d-flex justify-content-center align-items-center">
                    <div className={bgImage}></div>
                  </div>
                )}
              </div>
            </div>
            <button
              className="btn btn-primary shadow"
              onClick={() => handleLanguage()}
              title={
                selectedLanguage === "ar"
                  ? "Change to English"
                  : "التغيير إلى اللغة العربية"
              }
              style={{
                position: "fixed",
                bottom: "60px",
                right: "40px",
                zIndex: 999,
                // borderRadius: "50%",
                width: "40px",
                height: "40px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "25px",
              }}
            >
              {/* {selectedLanguage === "en" ? "English" : "الإنجليزية"} */}
              {selectedLanguage === "ar" ? "En" : " ب"}
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default ContainerLayout;
